export const featureNames = {
  forecastManagement: 'feature.forecastManagement'
}
